import { observable } from "mobx";

const config = observable({
  debug: false,
  primaryBackgroundColor: "#38B097",
  primaryColor: "#38B097",
  background: "#CBCBCB",
  modes: {
    mark: {
      defaultColors: ["#40CC3A", "#FF6245", "#749BD0"],
    },
  },
  canvas: {
    size: 30000,
  },
  clouds: {
    wordLimit: 200,
    padding: 40,
  },
  word: {
    padding: {
      x: 10,
      y: 8,
    },
    margin: {
      x: 0,
      y: 0,
    },
    font: {
      weight: 400,
      size: 16,
      family: "Rubik",
    },
  },
  mainWord: {
    padding: {
      x: 10,
      y: 8,
    },
    margin: {
      x: 0,
      y: 0,
    },
    font: {
      weight: 500,
      size: 22,
      family: "Rubik",
    },
  },
});

(window as any).config = config;

export default config;
